/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiEntityType } from './InternalApiEntityType';
import {
    InternalApiEntityTypeFromJSON,
    InternalApiEntityTypeFromJSONTyped,
    InternalApiEntityTypeToJSON,
    InternalApiEntityTypeToJSONTyped,
} from './InternalApiEntityType';
import type { InternalApiCustomListSignificantFieldConf } from './InternalApiCustomListSignificantFieldConf';
import {
    InternalApiCustomListSignificantFieldConfFromJSON,
    InternalApiCustomListSignificantFieldConfFromJSONTyped,
    InternalApiCustomListSignificantFieldConfToJSON,
    InternalApiCustomListSignificantFieldConfToJSONTyped,
} from './InternalApiCustomListSignificantFieldConf';

/**
 * 
 * @export
 * @interface InternalApiCustomListSignificantFields
 */
export interface InternalApiCustomListSignificantFields {
    /**
     * 
     * @type {InternalApiEntityType}
     * @memberof InternalApiCustomListSignificantFields
     */
    entityType: InternalApiEntityType;
    /**
     * 
     * @type {Array<InternalApiCustomListSignificantFieldConf>}
     * @memberof InternalApiCustomListSignificantFields
     */
    _configuration: Array<InternalApiCustomListSignificantFieldConf>;
}



/**
 * Check if a given object implements the InternalApiCustomListSignificantFields interface.
 */
export function instanceOfInternalApiCustomListSignificantFields(value: object): value is InternalApiCustomListSignificantFields {
    if (!('entityType' in value) || value['entityType'] === undefined) return false;
    if (!('_configuration' in value) || value['_configuration'] === undefined) return false;
    return true;
}

export function InternalApiCustomListSignificantFieldsFromJSON(json: any): InternalApiCustomListSignificantFields {
    return InternalApiCustomListSignificantFieldsFromJSONTyped(json, false);
}

export function InternalApiCustomListSignificantFieldsFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiCustomListSignificantFields {
    if (json == null) {
        return json;
    }
    return {
        
        'entityType': InternalApiEntityTypeFromJSON(json['entityType']),
        '_configuration': ((json['configuration'] as Array<any>).map(InternalApiCustomListSignificantFieldConfFromJSON)),
    };
}

export function InternalApiCustomListSignificantFieldsToJSON(json: any): InternalApiCustomListSignificantFields {
    return InternalApiCustomListSignificantFieldsToJSONTyped(json, false);
}

export function InternalApiCustomListSignificantFieldsToJSONTyped(value?: InternalApiCustomListSignificantFields | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'entityType': InternalApiEntityTypeToJSON(value['entityType']),
        'configuration': ((value['_configuration'] as Array<any>).map(InternalApiCustomListSignificantFieldConfToJSON)),
    };
}

